//TODO: Student history (Ready on the student page / In progress on the course page)
//TODO: Отмена посещения и возврат денег
const attendanceModal = document.getElementById('attendanceModal');

/**
 * Renders the student list for attendance tracking
 * Creates a table-like structure with student information and attendance checkboxes
 * @param {Array} data - Array of student objects containing id, name, surname, balance, and currency symbol
 */
const attendanceStuList = (data) => {
    const stuContainer = document.getElementById('attendanceStuList');

    // Create table header
    stuContainer.innerHTML = `
            <div class="row fw-bold pb-2 mb-2">
                <div class="col fst-italic" style="max-width: 40px;">&#8470;</div>
                <div class="col-4 fst-italic">Name</div>
                <div class="col-1 text-end fst-italic">Balance</div>
                <div class="col fst-italic">Comment</div>
                <div class="col fst-italic" style="max-width: 116px;">Attendance</div>
                <div class="col-1 text-end fst-italic" style="max-width: 62px;">Paid</div>
                <div class="col-1 text-end fst-italic" style="max-width: 62px;">Trial</div>
            </div>
        `;

    // Generate row for each student
    data.forEach((item, index) => {
        const stuRow = document.createElement('div');

        stuRow.classList.add('stu-item', 'row', 'py-2', 'align-items-center');
        // Add alternating background color for better readability
        if (index % 2 === 0) stuRow.classList.add('bg-light', 'rounded-4');
        //TODO: Checkbox input - Trail Lesson - ?
        stuRow.innerHTML = `
                <div class="col" style="max-width: 40px;">${index + 1}</div>
                <div class="col-4">${item.name} ${item.surname}</div>
                <div class="col-1 text-end ${item.balance < 0 ? 'text-danger' : 'text-success'}">${item.symbol === 'EUR' ? '&euro;' : item.symbol === 'USD' ? '&dollar;' : item.symbol} ${item.balance}</div>
                <div class="col"><input name="comment" type="text" class="form-control" value="${item.comment !== null ? item.comment : ''}"></div>
                <div class="col form-check d-flex justify-content-center align-items-center" style="max-width: 112px;">
                    <input class="stuID form-check-input" type="checkbox" value="${item.id}" id="sid-${item.id}" ${item.attendance_date ? 'checked disabled' : ''}>
                </div>
                <div class="col-1 form-check d-flex justify-content-end align-items-center" style="max-width: 62px;">
                    <input id="paid-${item.id}" class="stuPaid form-check-input" type="checkbox" value="1">
                </div>
                <div class="col-1 form-check d-flex justify-content-end align-items-center" style="max-width: 62px;">
                    <input id="trial-${item.id}" class="stuTrial form-check-input" type="checkbox" value="1">
                </div>
            `;
        stuContainer.appendChild(stuRow);
    })
}

if (attendanceModal) {
    const attendanceModalForm = attendanceModal.querySelector('form');
    const groupSelect = attendanceModalForm.querySelector('#attendanceModalGroup');
    const attendanceModalDate = document.getElementById('attendanceModalDate');
    let groupStudentList = '';

    /**
     * Populates the group select dropdown with available groups
     * Filters out deleted groups (del > 0) and creates option elements
     * @param {Array} data - Array of group objects containing id, comment, and del status
     */
    const groupOptions = (data) => {
        if (data.length > 1) {
            // data.filter((item, index) => item.del > 0).forEach((item, index) => {
            //     const option = new Option(item.comment, item.id);
            //     //option.dataset.key = index + 1;
            //     option.dataset.key = index;
            //     groupSelect.add(option);
            // })
            data.forEach((item, index) => {
                const option = new Option(item.comment, item.id);
                option.dataset.key = index;
                groupSelect.add(option);
            });
        }
    }

    /**
     * Event handler for showing the attendance modal
     * Initializes the modal with current date, fetches course groups and students
     * Triggered when modal is opened via Bootstrap modal show event
     */
    attendanceModal.addEventListener('show.bs.modal', async event => {
        const cid = event.relatedTarget.dataset.cid;
        let gid = event.relatedTarget.dataset.gid;
        const today = new Date().toISOString().split('T')[0];
        const timestamp = Math.floor(new Date(today + 'T00:00:00Z').getTime() / 1000);

        attendanceModalDate.value = today;
        attendanceModalDate.setAttribute('max', today);

        try {
            addPreloader(attendanceModal.querySelector('#attendanceStuList'));
            // получить группы и выбрать gid, если он не передан
            const groupsResp = await postData('/actions/dash/attendance.php', {act: 4, cid: cid});
            groupOptions(groupsResp.success);
            gid = gid || (groupsResp.success && groupsResp.success[0] && groupsResp.success[0].id);

            // установить выбранную опцию в селекте, если нужно
            if (gid && groupSelect) groupSelect.value = gid;

            // затем запросить список студентов с правильным gid
            const data = await postData('/actions/dash/attendance.php', {act: 2, gid: gid, date: timestamp});

            // добавить скрытый cid один раз
            if (!attendanceModalForm.querySelector('input[name="cid"]')) {
                const cidInput = document.createElement('input');
                cidInput.name = 'cid';
                cidInput.type = 'hidden';
                cidInput.value = cid;
                attendanceModalForm.appendChild(cidInput);
            } else {
                attendanceModalForm.querySelector('input[name="cid"]').value = cid;
            }

            attendanceStuList(data['success']);
            removePreloader(attendanceModal.querySelector('.preloader'));
        } catch (err) {
            console.error('Attendance modal init error:', err);
        }
    })

    /**
     * Event handler for cleaning up when modal is hidden
     * Resets all form fields and clears dynamic content
     */
    attendanceModal.addEventListener('hidden.bs.modal', event => {
        document.getElementById('attendanceModalDate').value = '';
        document.getElementById('attendanceModalGroup').innerHTML = '';
        document.getElementById('attendanceStuList').innerHTML = '';
    })

    /**
     * Event handler for group selection change
     * Updates the student list based on the selected group
     */
    groupSelect.addEventListener('change', (e) => {
        const selectedOption = e.currentTarget.selectedOptions[0];
        //const selectedKey = selectedOption.dataset.key;
        //attendanceStuList(groupStudentList[selectedKey]['students'])
        const selectedKey = selectedOption.value;
        const selectedDate = new Date(document.getElementById('attendanceModalDate').value);
        const timestamp = Math.floor(selectedDate.getTime() / 1000);
        postData('/actions/dash/attendance.php', {act: 2, gid: selectedKey, date: timestamp}).then(data => {
            attendanceStuList(data['success']);
        })
    })

    /**
     * Event handler for date change in attendance modal
     * Fetches and displays student attendance data for the selected date
     * Converts date to Unix timestamp for API request
     */
    attendanceModalDate.addEventListener('change', (e) => {
        const selectedDate = new Date(e.currentTarget.value);
        const timestamp = Math.floor(selectedDate.getTime() / 1000); // Convert to seconds since epoch
        const selectedGroup = document.getElementById('attendanceModalGroup').value;

        postData('/actions/dash/attendance.php', {act: 2, gid: selectedGroup, date: timestamp})
            .then(data => {
                attendanceStuList(data['success']);
            })
            .catch(error => {
                console.error('Error fetching attendance data:', error);
            })
    })

    /**
     * Event handler for submitting attendance
     * Collects checked students, sends data to server, and shows success notification
     * Displays loading spinner during submission
     */
    const attendanceBtn = document.getElementById('attendanceBtn');
    attendanceBtn.addEventListener('click', (e) => {
        // Create and display loading spinner
        let preloader = document.createElement('div');
        preloader.classList.add('position-absolute', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2');
        preloader.style.cssText = 'left: 1rem;right: 1rem;top: 1rem;bottom: 1rem;background: rgba(255,255,255, 0.5);';
        preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
        document.querySelector('#attendanceModal .modal-content').appendChild(preloader);

        /*
        // Collect all checked student IDs
        let attendanceValuesList = [...document.querySelectorAll('#attendanceStuList input:checked')].map(elem => elem.value);
        attendanceValuesList = JSON.stringify(attendanceValuesList);

        // Prepare form data with student list
        const formData = new FormData(attendanceModalForm);
        formData.append('stulist', attendanceValuesList);

        const values = Object.fromEntries(formData.entries());

        // Submit attendance data
        postData('/actions/dash/attendance.php', values).then(data => {
            if (data.success) {
                preloader.remove();

                // Show success toast notification
                document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">${data.success}</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;
                const toastLive = document.getElementById('liveToast')
                const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
                toastBootstrap.show();

                // Clean up toast after it's hidden
                toastLive.addEventListener('hidden.bs.toast', () => {
                    toastLive.remove();
                });

                // Close the modal
                let modal = bootstrap.Modal.getInstance(attendanceModal);
                modal.hide();
            }
        }).catch(error => {
            console.error('Error submitting attendance:', error);
            preloader.remove();
        });
        */

        const stuList = document.querySelectorAll('.stu-item');
        const attendanceValuesList = [];

        stuList.forEach(item => {
            const idInput = item.querySelector('.stuID');

            if (idInput.checked) {
                const id = idInput.value;
                const comment = item.querySelector('input[name="comment"]').value;
                const paid = item.querySelector('.stuPaid').checked ? 1 : 0;
                const trial = item.querySelector('.stuTrial').checked ? 1 : 0;
                
                //if (!idInput.disabled) {
                    attendanceValuesList.push({
                        id: id,
                        paid: paid,
                        trial: trial,
                        comment: comment
                    });
                //}
            }
        });

        const formData = new FormData(attendanceModalForm);
        formData.append('stulist', JSON.stringify(attendanceValuesList));
        //formData.append('stulist', attendanceValuesList);
        formData.append('date', attendanceModalDate.value);
        formData.append('gid', groupSelect.value);
        formData.append('cid', attendanceModalForm.querySelector('input[name="cid"]').value);

        const values = Object.fromEntries(formData.entries());
        postData('/actions/dash/attendance.php', values).then(data => {
            if (data.success) {
                preloader.remove();
                document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">${data.success}</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;
                const toastLive = document.getElementById('liveToast')
                const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
                toastBootstrap.show();

                // Clean up toast after it's hidden
                toastLive.addEventListener('hidden.bs.toast', () => {
                    toastLive.remove();
                });

                // Close the modal
                let modal = bootstrap.Modal.getInstance(attendanceModal);
                modal.hide();
            }
        }).catch(error => {
            console.error('Error submitting attendance:', error);
            preloader.remove();
        });

        console.log(Object.fromEntries(formData.entries()));
    })
}

//Attendance list in the profile modal and course page
const attendanceModalProfile = document.getElementById('attendanceModalProfile');

if (attendanceModalProfile) {
    const viewer = parseInt(document.getElementById('view').dataset.viewer, 10);
    const attendanceListProfile = (data) => {
        const attendanceListContainer = document.getElementById('attendanceList');
        attendanceListContainer.innerHTML = '';

        if (data && data.length > 0) {
            const table = document.createElement('table');
            table.classList.add('table', 'table-striped', 'mb-0');

            const thead = document.createElement('thead');
            thead.innerHTML = `
                <tr>
                    <th>Date</th>
                    <th>Course</th>
                    <th>Group</th> 
                    ${viewer !== 4 ? '<th>Actions</th>' : ''}
                </tr>
            `;
            table.appendChild(thead);

            const tbody = document.createElement('tbody');

            data.forEach(record => {
                const tr = document.createElement('tr');
                let date = new Date(record.date * 1000);
                date = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

                tr.innerHTML = `
                    <td>${date}</td>
                    <td>${record.course_name}</td>
                    <td>${record.group_name}</td>
                `;

                if (viewer !== 4) {
                    console.log(record);
                    const td = document.createElement('td');
                    const attDeleteBtn = document.createElement('button');
                    attDeleteBtn.className = 'btn btn-danger btn-sm del-stu-att ms-2';
                    attDeleteBtn.title = 'Remove';
                    attDeleteBtn.dataset.gid = record.gid;
                    attDeleteBtn.dataset.sid = record.sid;
                    attDeleteBtn.dataset.date = record.date;
                    attDeleteBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="#fff" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"></path></svg>`;
                    td.appendChild(attDeleteBtn);
                    tr.appendChild(td);
                }

                tbody.appendChild(tr);
            });

            table.appendChild(tbody);
            attendanceListContainer.appendChild(table);
        } else {
            attendanceListContainer.innerHTML = '<p class="mt-3">No attendance records found.</p>';
        }
    }
    attendanceModalProfile.addEventListener('show.bs.modal', (e) => {
        //let sid = document.querySelector('.profile').dataset.sid;
        let sid = e.relatedTarget.dataset.sid;
        let stuName = e.relatedTarget.dataset.stuname;

        if (stuName) {
            attendanceModalProfile.querySelector('.modal-title').innerHTML = `Attendance for ${stuName}`;
        }

        document.getElementById('attendanceList').innerHTML = '';
        postData('/actions/dash/attendance.php', {act: 3, sid: sid})
            .then(data => {
                attendanceListProfile(data['success']);
            })
            .catch(error => {
                console.error('Error fetching attendance data:', error);
            })
    })
}